import { API_BASE, ODATA_BASE, MEDIA_BASE } from "helpers/api_config";
import { gorselYuklemeParametreleri } from "helpers/gorselKucult";
import { stripHtml, truncate } from "helpers/contentUtils";
import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Status } from "./contactlistCol";


//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';
import "jspdf-autotable";
import Dropzone from 'react-dropzone-uploader';

import {
  getSliders as onGetSliders,
  addSlider as onAddSlider,
  updateSlider as onUpdateSlider,
  deleteSlider as onDeleteSlider,
} from "store/contacts/actions";
import { isEmpty } from "lodash";
//redux
import { useSelector, useDispatch } from "react-redux";

import SayfaRehberi from "../../../components/Common/SayfaRehberi";
/**
 * Bir slider kaydinin tiklaninca nereye gidecegini bulur.
 * Mobil uygulamadaki oncelik sirasiyla ayni (MainCategorySelect.js -> _renderSlider):
 * link > anasayfa kategorisi > spor > ilan > haber > forum
 */
const describeSliderTarget = row => {
  if (row.Sliders_Link) {
    return {
      type: "Dış link",
      color: "primary",
      text: row.Sliders_Link,
      href: row.Sliders_Link,
    };
  }
  if (row.MainPage_Category) {
    return {
      type: "Anasayfa kategorisi",
      color: "success",
      text: stripHtml(row.MainPage_Category.MainPage_Category_Title),
    };
  }
  if (row.SportCheck) {
    return { type: "Spor", color: "info", text: "Spor sayfası" };
  }
  if (row.Job_Advertisement) {
    return {
      type: "İş ilanı",
      color: "warning",
      text: stripHtml(row.Job_Advertisement.Job_Advertisement_Title),
    };
  }
  if (row.News) {
    return {
      type: "Aktüel",
      color: "danger",
      text: stripHtml(row.News.News_Title),
    };
  }
  if (row.Forum) {
    return {
      type: "Forum",
      color: "secondary",
      text: stripHtml(row.Forum.Forum_Title),
    };
  }
  return { type: "Yönlendirme yok", color: "light", text: "—" };
};

const ContactsList = props => {

  //meta title
  document.title = "Slider | BERLİN ESNAF ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();

  const [getFileName, setFileName] = useState(null);
  const [getFileType, setFileType] = useState(null);


  const [getJobAdvID, setJobAdvID] = useState(null);
  const [getForumID, setForumID] = useState(null);
  const [getNewsID, setNewsID] = useState(null);

  const [getNews, setNews] = useState([]);
  const [getForum, setForum] = useState([]);
  const [getJobAdv, setJobAdv] = useState([]);
  const [getIsActive, setIsActive] = useState(true);
  const [getIsActiveSpor, setIsActiveSpor] = useState(false);

  
  // Boş seçim/boş metin null'a çevrilir — aksi halde DB'ye "" ya da NaN gider
  const toNullableText = v => (v != null && String(v).trim() !== "" ? String(v).trim() : null);
  const toNullableInt = v => {
    const n = parseInt(v, 10);
    return Number.isNaN(n) ? null : n;
  };

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      title: (contactEdit && contactEdit.Sliders_Title) || "",

      sort: (contactEdit && contactEdit.Sort) || null,

      link: (contactEdit && contactEdit.Sliders_Link) || null,
    },
    validationSchema: Yup.object({
      // Baslik ZORUNLU DEGIL: kayitli sliderlarin cogunun basligi bos.
      // Zorunluyken, mevcut bir slider duzenlenip yonlendirme secildiginde
      // form dogrulamada takiliyor, "Kaydet" hicbir sey yapmiyordu.
      title: Yup.string()
        .trim()
        .nullable()
        .max(200, "Başlık en fazla 200 karakter olabilir"),
      sort: Yup.number()
        .transform(v => (Number.isNaN(v) ? null : v))
        .nullable()
        .integer("Sıralama tam sayı olmalı")
        .min(0, "Sıralama 0 veya daha büyük olmalı"),
      link: Yup.string()
        .trim()
        .nullable()
        .matches(/^https?:\/\/.+/i, {
          message: "Link http:// veya https:// ile başlamalı",
          excludeEmptyString: true,
        }),
    }),
    onSubmit: values => {
      if (isEdit) {

        const updateUser = {
          ID: contactEdit.ID,
          Sliders_Image: getFileName,
          Sliders_Title:values.title,
          SliderTypeId: toNullableInt(getCategoryID),
          News_ID: toNullableInt(getNewsID),
          Forum_ID: toNullableInt(getForumID),
          Job_Advertisement_ID: toNullableInt(getJobAdvID),
          SportCheck:getIsActiveSpor,
          IsActive:getIsActive,
          Sort : toNullableInt(values.sort),
          MainPage_Category_ID : toNullableInt(getCategoryIDMain),
          Sliders_Link: toNullableText(values.link),
          Sliders_UrlType:getFileType
        };
        
        console.log("şlmsfş123",updateUser)

        dispatch(onUpdateSlider(updateUser));
        setIsEdit(false);
        validation.resetForm();
      } else {
        const newUser = {
          Sliders_Image: getFileName,
          Sliders_Title:values["title"],
          SliderTypeId: toNullableInt(getCategoryID),
          News_ID: toNullableInt(getNewsID),
          Forum_ID: toNullableInt(getForumID),
          Job_Advertisement_ID: toNullableInt(getJobAdvID),
          SportCheck:getIsActiveSpor,
          IsActive:getIsActive,
          Sort: toNullableInt(values["sort"]),
          MainPage_Category_ID : toNullableInt(getCategoryIDMain),
          Sliders_Link: toNullableText(values["link"]),
          Sliders_UrlType:getFileType

        };
        console.log("newUser123",newUser)
        // save new user
        dispatch(onAddSlider(newUser));
        validation.resetForm();
      }
      toggle();
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.sliders,
  }));

  const [modal, setModal] = useState(false);

  const [isEdit, setIsEdit] = useState(false);
  const [getCategoryID, setCategoryID] = useState(null);
  const [getCategoryIDMain, setCategoryIDMain] = useState(null);

  
  const [getCategory, setCategory] = useState([]);
  const [getCategoryMain, setCategoryMain] = useState([]);


  // Slider satirlari: her kayitta yonlendirme hedeflerinden yalnizca biri dolu
  // oldugu icin ayri ayri kolon yerine tek "Yonlendirme" kolonunda gosteriliyor.
  // Oncelik sirasi mobil uygulamayla ayni: link > kategori > spor > ilan > haber > forum
  const columns = useMemo(
    () => [
      {
        Header: "Medya",
        accessor: "Sliders_Image",
        disableFilters: true,
        disableSortBy: true,
        Cell: cellProps => {
          const row = cellProps.row.original;
          const src = row.Sliders_Image
            ? `${MEDIA_BASE}/${row.Sliders_Image}`
            : null;
          const isVideo =
            row.Sliders_UrlType && String(row.Sliders_UrlType).startsWith("video");

          if (!src) {
            return (
              <div className="avatar-sm">
                <span className="avatar-title rounded bg-light text-muted">
                  {stripHtml(row.Sliders_Title).charAt(0) || "?"}
                </span>
              </div>
            );
          }

          return isVideo ? (
            <video
              width={120}
              height={70}
              controls
              style={{ borderRadius: 6, background: "#000" }}
            >
              <source src={src} type={row.Sliders_UrlType} />
              Tarayıcınız video etiketini desteklemiyor.
            </video>
          ) : (
            <a href={src} target="_blank" rel="noreferrer">
              <img
                src={src}
                alt=""
                style={{
                  width: 120,
                  height: 70,
                  objectFit: "cover",
                  borderRadius: 6,
                }}
              />
            </a>
          );
        },
      },

      {
        Header: "Başlık",
        accessor: "Sliders_Title",
        filterable: true,
        Cell: cellProps => {
          const row = cellProps.row.original;
          const title = stripHtml(row.Sliders_Title);
          return (
            <div style={{ minWidth: 160 }}>
              <div className="fw-bold">{title || <em>Başlıksız</em>}</div>
              <div className="text-muted font-size-11">#{row.ID}</div>
            </div>
          );
        },
      },

      {
        Header: "Yönlendirme",
        accessor: "Sliders_Link",
        filterable: true,
        Cell: cellProps => {
          const target = describeSliderTarget(cellProps.row.original);
          return (
            <div style={{ minWidth: 200 }}>
              <span className={`badge badge-soft-${target.color} font-size-11`}>
                {target.type}
              </span>
              <div
                className="text-muted font-size-12 mt-1"
                style={{ wordBreak: "break-word" }}
              >
                {target.href ? (
                  <a href={target.href} target="_blank" rel="noreferrer">
                    {truncate(target.text, 60)}
                  </a>
                ) : (
                  truncate(target.text, 60)
                )}
              </div>
            </div>
          );
        },
      },

      {
        Header: "Sıra",
        accessor: "Sort",
        filterable: true,
        Cell: cellProps => (
          <span className="badge badge-soft-primary font-size-12">
            {cellProps.value != null ? cellProps.value : "-"}
          </span>
        ),
      },

      {
        Header: "Durum",
        accessor: "IsActive",
        filterable: true,
        Cell: cellProps => {
          const row = cellProps.row.original;
          return (
            <div className="d-flex flex-column gap-1">
              <Status {...cellProps} />
              {row.SportCheck ? (
                <span className="badge badge-soft-info font-size-11">Spor</span>
              ) : null}
            </div>
          );
        },
      },

      {
        Header: "İşlemler",
        disableFilters: true,
        disableSortBy: true,
        Cell: cellProps => {
          const row = cellProps.row.original;
          const editId = `slider-edit-${row.ID}`;
          const deleteId = `slider-delete-${row.ID}`;
          return (
            <div className="d-flex gap-3">
              <Link
                to="#"
                className="text-success"
                onClick={() => handleUserClick(row)}
              >
                <i className="mdi mdi-pencil font-size-18" id={editId} />
                <UncontrolledTooltip placement="top" target={editId}>
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => onClickDelete(row)}
              >
                <i className="mdi mdi-delete font-size-18" id={deleteId} />
                <UncontrolledTooltip placement="top" target={deleteId}>
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  const _getAuthData = async () => {

    await axios.get(`${ODATA_BASE}/SliderTypes`)
      .then((res) => {
        setCategory(res.data.value || [])
      })
  }

  const _getCategoryBerlin = async () => {

    await axios.get(`${ODATA_BASE}/MainPage_Category?$orderby=MainPage_Category_Sort asc`)
      .then((res) => {
        setCategoryMain(res.data.value || [])
      })
  }


  const _getJobAdvData = async () => {

    await axios.get(`${ODATA_BASE}/Job_Advertisement?$orderby=ID desc`)
      .then((res) => {
        setJobAdv(res.data.value || [])
      })
  }


  const _getNewsData = async () => {

    await axios.get(`${ODATA_BASE}/News?$orderby=ID desc`)
      .then((res) => {
        setNews(res.data.value || [])
      })
  }


  const _getForumData = async () => {

    await axios.get(`${ODATA_BASE}/Forum?$orderby=ID desc`)
      .then((res) => {
        setForum(res.data.value || [])
      })
  }


  useEffect(() => {
    _getJobAdvData()
  }, []); // sadece mount: dep icinde set edilen state vardi -> sonsuz dongu

  useEffect(() => {
    _getNewsData()
  }, []); // sadece mount: dep icinde set edilen state vardi -> sonsuz dongu

  useEffect(() => {
    _getForumData()
  }, []); // sadece mount: dep icinde set edilen state vardi -> sonsuz dongu


  useEffect(() => {
    _getAuthData()
  }, []); // sadece mount: dep icinde set edilen state vardi -> sonsuz dongu

  useEffect(() => {
    _getCategoryBerlin()
  }, []); // sadece mount: dep icinde set edilen state vardi -> sonsuz dongu

  useEffect(() => {
    if (users && !users.length) {
      dispatch(onGetSliders());
      setIsEdit(false);
    }
  }, [dispatch, users]);

  const toggle = () => {
    setModal(!modal);
  };


  const handleUserClick = (arg) => {
    const user = arg;

    setEditContact(user);
    setFileType(user.Sliders_UrlType)
    setFileName(user.Sliders_Image)


    setCategoryID(user.SliderTypeId)

    setForumID(user.Forum_ID)
    setJobAdvID(user.Job_Advertisement_ID)
    setNewsID(user.News_ID)
    setIsEdit(true);

    setIsActiveSpor(user.SportCheck)
    setIsActive(user.IsActive)

    setCategoryIDMain(user.MainPage_Category_ID)
    toggle();
  };

  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = users => {
    setContact(users);
    setDeleteModal(true);
  };
  // NOT: burada `setContact(<liste>)` çağıran iki useEffect vardı.
  // `contact` SEÇİLİ SATIRI tutuyor; liste her değiştiğinde tüm dizi ile
  // eziliyor, dizide `.ID` olmadığı için silme sessizce hiçbir şey yapmıyordu.

  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteSlider(contact.ID));
    }
    setContact(undefined);
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setIsEdit(false);
    // Yeni kayıt: bir önceki düzenlemeden kalan seçimleri temizle
    setEditContact(null);
    setFileName(null);
    setFileType(null);
    setCategoryID(null);
    setCategoryIDMain(null);
    setNewsID(null);
    setForumID(null);
    setJobAdvID(null);
    setIsActive(true);
    setIsActiveSpor(false);
    validation.resetForm();
    toggle();
  };

  const _setChoiceCategory = arg => {
    setCategoryID(arg.target.value)
  }

  /**
   * Yonlendirme hedefleri: mobil uygulama tiklamada yalnizca EN ONCELIKLI olani
   * kullaniyor (link > anasayfa kategorisi > spor > ilan > haber > forum).
   * Bu yuzden panelde de tek hedef secilebiliyor; biri secilince digerleri
   * temizleniyor, boylece "sectim ama calismiyor" durumu olusmuyor.
   */
  const _setTarget = (kind, value) => {
    const val = value === "" ? null : value
    setCategoryIDMain(kind === "mainCategory" ? val : null)
    setJobAdvID(kind === "jobAdv" ? val : null)
    setNewsID(kind === "news" ? val : null)
    setForumID(kind === "forum" ? val : null)
    if (val && kind !== "sport") setIsActiveSpor(false)
  }

  const _setChoiceCategoryMain = arg => _setTarget("mainCategory", arg.target.value)
  const _setChoiceNews = arg => _setTarget("news", arg.target.value)
  const _setChoiceForum = arg => _setTarget("forum", arg.target.value)
  const _setChoiceJobAdv = arg => _setTarget("jobAdv", arg.target.value)

  // Formdaki secimlere gore tiklamada gercekten hangi hedefin calisacagi
  const effectiveTarget = (() => {
    const link = (validation.values.link || "").trim()
    if (link) return "Dış link: " + link
    if (getCategoryIDMain) {
      const item = getCategoryMain.find(x => String(x.ID) === String(getCategoryIDMain))
      return "Anasayfa kategorisi: " + ((item && item.MainPage_Category_Title) || getCategoryIDMain)
    }
    if (getIsActiveSpor) return "Spor sayfası"
    if (getJobAdvID) {
      const item = getJobAdv.find(x => String(x.ID) === String(getJobAdvID))
      return "İş ilanı: " + stripHtml((item && item.Job_Advertisement_Title) || getJobAdvID)
    }
    if (getNewsID) {
      const item = getNews.find(x => String(x.ID) === String(getNewsID))
      return "Aktüel: " + stripHtml((item && item.News_Title) || getNewsID)
    }
    if (getForumID) {
      const item = getForum.find(x => String(x.ID) === String(getForumID))
      return "Forum: " + stripHtml((item && item.Forum_Title) || getForumID)
    }
    return null
  })()

  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box">
        <img src={previewUrl} /> <span className="name">{name}</span> - <span className="status">{status == "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    )
  }


  // Gorseller yuklenmeden once kucultulur (bkz. helpers/gorselKucult.js)
  const getUploadParams = gorselYuklemeParametreleri


  const handleChangeStatus = ({ file, xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          setFileName(result.file.filename)
          setFileType(file.type);            // örnek: 'image/png', 'video/mp4'

        }
      }
    }
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="Slider Listesi" />
          <SayfaRehberi sayfa="slider" />

          {/* Hedefi olmayan slider'lar tiklaninca hicbir yere gitmiyor */}
          {(() => {
            const active = (users || []).filter(u => u.IsActive);
            const missing = active.filter(
              u => describeSliderTarget(u).type === "Yönlendirme yok"
            ).length;
            if (!missing) return null;
            return (
              <div className="alert alert-warning py-2 font-size-13">
                <i className="bx bx-error-circle align-middle me-1" />
                Yayındaki <strong>{active.length}</strong> slider&apos;dan{" "}
                <strong>{missing}</strong> tanesinin yönlendirmesi yok —
                tıklanınca hiçbir yere gitmiyor. Kaydı düzenleyip
                &quot;Link&quot; alanını doldurabilir ya da anasayfa
                kategorisi / haber / forum / ilan seçebilirsiniz.
              </div>
            );
          })()}

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={users}
                    isGlobalFilter={true}
                    isAddSlider={true}
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />
             
             
                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Slider Düzenle" : "Slider Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>



                            <div className="mb-3">
                              <Label className="form-label">Başlık <span className="text-danger">*</span></Label>
                              <Input
                                name="title"
                                label="title"
                                type="text"
                                placeholder="Başlık Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.title || ""}
                                invalid={
                                  validation.touched.title &&
                                    validation.errors.title
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.title &&
                                validation.errors.title ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.title}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="form-label">Sıralama</Label>
                              <Input
                                name="sort"
                                label="sort"
                                type="number"
                                placeholder="Sıralama Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.sort || ""}
                                invalid={
                                  validation.touched.sort &&
                                    validation.errors.sort
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.sort &&
                                validation.errors.sort ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.sort}
                                </FormFeedback>
                              ) : null}
                            </div>



                            {/* Yonlendirme ozeti: kullanici hangi hedefin gecerli
                                olacagini kaydetmeden once gorsun */}
                            <div
                              className={
                                "alert " +
                                (effectiveTarget ? "alert-info" : "alert-warning") +
                                " py-2 font-size-12"
                              }
                            >
                              <i className="bx bx-link-alt align-middle me-1" />
                              {effectiveTarget ? (
                                <>
                                  Tıklanınca gidilecek yer: <strong>{effectiveTarget}</strong>
                                </>
                              ) : (
                                "Henüz yönlendirme seçilmedi — slider tıklanınca hiçbir yere gitmez."
                              )}
                              <div className="mt-1">
                                Aşağıdaki hedeflerden yalnızca biri seçilebilir; link
                                alanı doluysa diğerlerinin hepsi geçersiz olur.
                              </div>
                            </div>

                            <div className="mb-3">
                              <Label className="form-label">Haber Seçiniz</Label>
                              <Input
                                name="newsId"
                                type="select"
                                className="form-select"
                                onChange={_setChoiceNews}
                                value={getNewsID || ""}>
                                  <option value="">Lütfen Seçim Yapınız</option>

                                {getNews.map((item, index) => (
                                  <option value={item.ID} key={item.ID}>{item.News_Title}</option>
                                ))}

                              </Input>
                            </div>


                            <div className="mb-3">
                              <Label className="form-label">Forum Seçiniz</Label>
                              <Input
                                name="forumId"
                                type="select"
                                className="form-select"
                                onChange={_setChoiceForum}
                                value={getForumID || ""}>
                                  <option value="">Lütfen Seçim Yapınız</option>

                                {getForum.map((item, index) => (
                                  <option value={item.ID} key={item.ID}>{item.Forum_Title}</option>
                                ))}

                              </Input>
                            </div>


                            <div className="mb-3">
                              <Label className="form-label">İlan Seçiniz</Label>
                              <Input
                                name="jobAdvId"
                                type="select"
                                className="form-select"
                                onChange={_setChoiceJobAdv}
                                value={getJobAdvID || ""}>
                                  <option value="">İlan Seçimi Yapınız</option>

                                {getJobAdv.map((item, index) => (
                                  <option value={item.ID} key={item.ID}>{item.Job_Advertisement_Title}</option>
                                ))}

                              </Input>
                            </div>

                            <div className="mb-3">
                              <Label className="form-label">Anasayfa Kategori Seçiniz</Label>
                              <Input
                                name="mainCategoryId"
                                type="select"
                                className="form-select"
                                onChange={_setChoiceCategoryMain}
                                value={getCategoryIDMain || ""}>
                                  
                                  <option value="">Lütfen Yönlendireceğiniz Sayfa Seçimini Yapınız</option>


                                {getCategoryMain.map((item, index) => (
                                  <option value={item.ID} key={item.ID}>{item.MainPage_Category_Title}</option>
                                ))}

                              </Input>
                            </div>

                            <div className="mb-3">
                              <Label className="form-label">Slider Kategori Seçiniz</Label>
                              <Input
                                name="sliderTypeId"
                                type="select"
                                className="form-select"
                                onChange={_setChoiceCategory}
                                value={getCategoryID || ""}>

<option value="">Lütfen Seçim Yapınız</option>


                                {getCategory.map((item, index) => (
                                  <option value={item.ID} key={item.ID}>{item.Title}</option>
                                ))}

                              </Input>
                            </div>

                            <div className="mb-3">
                              <Label className="form-label">Link</Label>
                              <Input
                                name="link"
                                label="link"
                                type="text"
                                placeholder="Link Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.link || ""}
                                invalid={
                                  validation.touched.link &&
                                    validation.errors.link
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.link &&
                                validation.errors.link ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.link}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Col xs={12} className="mb-3">
                                <label htmlFor="resume">Görsel</label>
                                <Dropzone
                                  getUploadParams={getUploadParams}
                                  onChangeStatus={handleChangeStatus}
                                  styles={{
                                    dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
                                    inputLabelWithFiles: { margin: '20px 3%' }
                                  }}

                                  canRemove={false}
                                  PreviewComponent={Preview}
                                  accept="image/*,video/mp4,video/webm,video/ogg,image/gif,video/mov"
                                />

                              </Col>

                              {getFileName != null ? (
  <div>
    {getFileType && getFileType.startsWith("video") ? (
      <video height="200" controls>
        <source src={'https://megasubdomain.stechomeyazilim.info/' + getFileName} type={getFileType} />
        Tarayıcınız video etiketini desteklemiyor.
      </video>
    ) : (
      <img
        className="avatar-xl"
        src={'https://megasubdomain.stechomeyazilim.info/' + getFileName}
        alt=""
      />
    )}
  </div>
) : null}

                            </div>

                            {/* Anahtarlarin yazi etiketleri htmlFor="resume" idi;
                                boyle bir alan yok, yani YAZIYA DOKUNMAK HICBIR SEY
                                YAPMIYORDU. Calisan tek yer 56x24'luk anahtarin
                                kendisiydi — telefonda tutturmasi neredeyse imkansiz.
                                Artik yazi da anahtari cevirir. */}
                            <div className="d-flex flex-wrap align-items-center gap-4">
                            <div className="d-flex align-items-center gap-2">
                              <label className="mb-0" htmlFor="square-switch1">Aktif Mi?</label>

                              <div className="square-switch">

                                <input
                                  type="checkbox"
                                  id="square-switch1"
                                  className="switch"
                                  checked={!!getIsActive}
                                  onChange={() =>
                                    setIsActive(!getIsActive)
                                  }
                                />
                                <label
                                  htmlFor="square-switch1"
                                  data-on-label="Aktif "
                                  data-off-label="Pasif"
                                />
                              </div>

                            </div>

                            <div className="d-flex align-items-center gap-2">
                              <label className="mb-0" htmlFor="square-switch2">Spora Yönlendir?</label>

                              <div className="square-switch">

                                <input
                                  type="checkbox"
                                  id="square-switch2"
                                  className="switch"
                                  checked={!!getIsActiveSpor}
                                  onChange={() => {
                                    const next = !getIsActiveSpor;
                                    // spor secilince diger hedefler temizlenir
                                    if (next) _setTarget("sport", true);
                                    setIsActiveSpor(next);
                                  }}
                                />
                                <label
                                  htmlFor="square-switch2"
                                  data-on-label="Aktif "
                                  data-off-label="Pasif"
                                />
                              </div>

                            </div>
                            </div>

                          </Col>
                        </Row>
                        <Row>



                          <Col>
                            {/* Dogrulama hatasi olunca Formik submit'i sessizce
                                iptal ediyor; kullanici "Kaydet'e bastim ama
                                hicbir sey olmuyor" durumuna dusmesin diye
                                hatalar burada toplu gosteriliyor. */}
                            {validation.submitCount > 0 &&
                            Object.keys(validation.errors).length > 0 ? (
                              <div className="alert alert-danger py-2 font-size-12">
                                Kaydedilemedi, lütfen düzeltin:
                                <ul className="mb-0 mt-1">
                                  {Object.values(validation.errors).map((err, i) => (
                                    <li key={i}>{String(err)}</li>
                                  ))}
                                </ul>
                              </div>
                            ) : null}
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);
